/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/* eslint-disable no-multi-spaces */

enum Images {
  Background   = 'assets/img/background.jpg',
  BMWAvatar    = 'assets/img/avatar.svg',
  BMWPoweredBy = 'assets/img/powered-by.svg',
  DefaultCar   = 'assets/img/defaultCar.svg',
  Location     = 'assets/img/location.svg',
  Mail         = 'assets/img/mail.svg',
  Phone        = 'assets/img/phone.svg'
};
export default Images;
